// селекты
const SortedSelect = require('./selects/sorted-select');

$(() => {
	SortedSelect.init();
});